import { c as _c } from "react/compiler-runtime";
import React from "react";
import AmountInputDefaultView from "./AmountInputDefaultView";
import { useAmountInput } from "./useAmountInput";
import type { AmountInputRootProps } from "./types";
export type { AmountInputDesign, AmountInputRootProps } from "./types";
export type { AmountInputProps, AmountType } from "../input.interface";
export { AmountInputDefaultView, useAmountInput };
export default function AmountInput(t0) {
  const $ = _c(11);
  let props;
  let render;
  let t1;
  if ($[0] !== t0) {
    ({
      design: t1,
      render,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = render;
    $[3] = t1;
  } else {
    props = $[1];
    render = $[2];
    t1 = $[3];
  }
  const design = t1 === undefined ? "default" : t1;
  const viewModel = useAmountInput(props);
  if (render) {
    let t2;
    if ($[4] !== render || $[5] !== viewModel) {
      t2 = render(viewModel);
      $[4] = render;
      $[5] = viewModel;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t2) {
      t3 = <>{t2}</>;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  switch (design) {
    case "default":
    default:
      {
        let t2;
        if ($[9] !== viewModel) {
          t2 = <AmountInputDefaultView {...viewModel} />;
          $[9] = viewModel;
          $[10] = t2;
        } else {
          t2 = $[10];
        }
        return t2;
      }
  }
}